// @greenlight-spec: 19-design-system.md
import * as React from 'react';

/**
 * True below the given breakpoint (default 768px = `md`, the point the sidebar
 * becomes the bottom nav and tables collapse to card lists). Pass another px
 * value to switch at a different breakpoint (e.g. 1024 for `lg`). SSR-safe
 * (defaults to desktop).
 */
export function useIsMobile(breakpoint = 768): boolean {
  const [mobile, setMobile] = React.useState<boolean>(() => {
    if (typeof window === 'undefined') return false;
    return !window.matchMedia(`(min-width: ${breakpoint}px)`).matches;
  });
  React.useEffect(() => {
    if (typeof window === 'undefined') return;
    const mql = window.matchMedia(`(min-width: ${breakpoint}px)`);
    const handler = (e: MediaQueryListEvent): void => setMobile(!e.matches);
    setMobile(!mql.matches);
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, [breakpoint]);
  return mobile;
}
